import ACTIONS from 'application/constants'
import default_store from '../../../default_store'

const aktenActionUnmarkFavoriteMessageReducer = (state = default_store.pages.akten.action.unmarkFavorite, action) => {
    switch (action.type) {
    case ACTIONS.PAGES_AKTEN_UNMARK_FAVORITE_MESSAGE_REQUEST: return {
        ...state,
        request: true,
        id: action.messageId,
    }
    case ACTIONS.PAGES_AKTEN_UNMARK_FAVORITE_MESSAGE_SUCCEED: return {
        ...state,
        request: false,
        succeed: true,
        id: null,
    }
    case ACTIONS.PAGES_AKTEN_UNMARK_FAVORITE_MESSAGE_FAILED: return {
        ...state,
        request: false,
        succeed: false,
        failed: true,
        id: null,
    }
    default:
        return state
    }
}

export default aktenActionUnmarkFavoriteMessageReducer